import { render, staticRenderFns } from "./CancelCollectBox.vue?vue&type=template&id=7eac0dc5&scoped=true"
import script from "./CancelCollectBox.vue?vue&type=script&lang=js"
export * from "./CancelCollectBox.vue?vue&type=script&lang=js"
import style0 from "./CancelCollectBox.vue?vue&type=style&index=0&id=7eac0dc5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eac0dc5",
  null
  
)

export default component.exports